import React, { useEffect, useRef } from 'react';
import { LuX } from 'react-icons/lu';
import ReactDOM from 'react-dom';
import { ContentHolder, Head, StyledModal } from './Modal.styles';
const modalRoot = document.getElementById('modal-root');

const CenterModal = ({
  children,
  open,
  setOpen,
  bg,
  padding,
  width,
  radius,
  desktopRight,
  desktopTop,
  setIsEditing,
  title,
  subtitle,
  headImage,
  isCloseAble = true,
  noHead,
  newStyle,
  closeClick,
  headerMarginBottom,
  onClose = () => {},
}) => {
  const modalRef = useRef();

  useEffect(() => {
    const disableScroll = () => {
      document.body.style.overflow = 'hidden';
    };

    const enableScroll = () => {
      document.body.style.overflow = 'auto';
    };

    if (open) {
      disableScroll();
    } else {
      enableScroll();
    }

    return () => {
      enableScroll();
    };
  }, [open]);

  const handleClose = () => {
    if (isCloseAble) {
      setOpen(false);
      onClose();
    }
    if (closeClick) {
      closeClick();
    }
  };

  const handleBackdropClick = e => {
    e.stopPropagation();
    handleClose();
  };
  return ReactDOM.createPortal(
    open && (
      <StyledModal
        ref={modalRef}
        open={open}
        onClick={handleBackdropClick}
        onKeyDown={e => {
          if (e.key === 'Escape') {
            handleClose();
          }
        }}>
        <ContentHolder
          bg={bg}
          padding={padding}
          width={width}
          radius={radius}
          desktopRight={desktopRight}
          desktopTop={desktopTop}
          newStyle={newStyle}
          role="dialog"
          aria-modal="true"
          onClick={e => e.stopPropagation()}
          tabIndex={-1}>
          {noHead ? (
            <></>
          ) : (
            <Head newStyle={newStyle} $headerMarginBottom={headerMarginBottom}>
              {title && (
                <strong className="title">
                  {title} <span className="subtitle">{subtitle}</span>
                </strong>
              )}
              {headImage && <img src={headImage} alt="Icon" />}
              {isCloseAble && (
                <button type="button" className="closer" onClick={handleClose} tabIndex={0} aria-label="Close">
                  <LuX className="Icon" />
                </button>
              )}
            </Head>
          )}
          {children}
        </ContentHolder>
      </StyledModal>
    ),
    modalRoot,
  );
};

export default CenterModal;
